import React, { useState, useEffect } from "react";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import "./CalendarioTab.scss";
import Button from "../../../common/Button/Button";
import Modal from "../../../common/Modal/Modal";
import InputSearch from "../../../common/Inputs/InputSearch/InputSearch";
import InputDropdown from "../../../common/Inputs/InputDropdown/InputDropdown";

const eventosGestores = [
    {
        id: 1,
        nombre: "Coração D´Aco, Lda",
        fecha: "2025-05-20",
        estado: "No válido",
        tipo: "Vencimiento documento",
        documento: "Certificado de gestión",
        proveedor: "Ambitei, S.A.",
        documentoCompleto:
            "Licença Ambitei - Ofício-DSA-DLPA 1141-2023_LECENÇA PROVISÓRIA_LABRORAÇÃO.pdf",
    },
    {
        id: 2,
        nombre: "EGGER ROMANIA SRL",
        fecha: "2025-06-05",
        estado: "No válido",
        tipo: "Renovación licencia",
        documento: "Licencia operativa",
        proveedor: "EGGER ROMANIA SRL",
        documentoCompleto: "EGGER_Licencia_Operativa_2024.pdf",
    },
    {
        id: 3,
        nombre: "RECINOR",
        fecha: "2025-06-05",
        estado: "No válido",
        tipo: "Auditoría pendiente",
        documento: "Informe de auditoría",
        proveedor: "RECINOR",
        documentoCompleto: "RECINOR_Auditoria_Pendiente_2024.pdf",
    },
    {
        id: 4,
        nombre: "RILO DOPICO",
        fecha: "2025-06-05",
        estado: "No válido",
        tipo: "Documentación incompleta",
        documento: "Certificado ambiental",
        proveedor: "RILO DOPICO",
        documentoCompleto: "RILO_DOPICO_Certificado_Ambiental.pdf",
    },
    {
        id: 5,
        nombre: "SC VITALIA SERVICII PENTRU MEDIU COLECTARE PRAHOVA",
        fecha: "2025-06-27",
        estado: "No válido",
        tipo: "Vencimiento seguro",
        documento: "Póliza de seguros",
        proveedor: "SC VITALIA",
        documentoCompleto: "SC_VITALIA_Poliza_Seguros_2024.pdf",
    },
    {
        id: 6,
        nombre: "ARINES, OBRAS Y PROYECTOS, S.L.",
        fecha: "2025-06-30",
        estado: "No válido",
        tipo: "Renovación certificado",
        documento: "Certificado ISO",
        proveedor: "ARINES",
        documentoCompleto: "ARINES_Certificado_ISO_2024.pdf",
    },
    {
        id: 7,
        nombre: "ESTRI SRL",
        fecha: "2025-07-03",
        estado: "No válido",
        tipo: "Vencimiento documento",
        documento: "Autorización municipal",
        proveedor: "ESTRI SRL",
        documentoCompleto: "ESTRI_Autorizacion_Municipal.pdf",
    },
    {
        id: 8,
        nombre: "Ambitei, S.A.",
        fecha: "2025-07-05",
        estado: "No válido",
        tipo: "Auditoría programada",
        documento: "Evaluación técnica",
        proveedor: "Ambitei, S.A.",
        documentoCompleto: "Ambitei_Evaluacion_Tecnica_2024.pdf",
    },
    {
        id: 9,
        nombre: "ESTRI SRL",
        fecha: "2025-07-06",
        estado: "No válido",
        tipo: "Revisión anual",
        documento: "Memoria técnica",
        proveedor: "ESTRI SRL",
        documentoCompleto: "ESTRI_Memoria_Tecnica_2024.pdf",
    },
    {
        id: 10,
        nombre: "CARMONA",
        fecha: "2025-08-17",
        estado: "Caducidad inminente",
        tipo: "Próximo vencimiento",
        documento: "Certificado de calidad",
        proveedor: "CARMONA",
        documentoCompleto: "CARMONA_Certificado_Calidad.pdf",
    },
    {
        id: 11,
        nombre: "Ambivator - Gestao Global de Residuos, Lda",
        fecha: "2025-10-03",
        estado: "Documento vigente",
        tipo: "Renovación programada",
        documento: "Licencia ambiental",
        proveedor: "Ambivator",
        documentoCompleto: "Ambivator_Licencia_Ambiental_2024.pdf",
    },
    {
        id: 12,
        nombre: "B.G.R. - Gestão de Resíduos, Lda.",
        fecha: "2025-10-18",
        estado: "Documento vigente",
        tipo: "Seguimiento rutinario",
        documento: "Informe técnico",
        proveedor: "B.G.R.",
        documentoCompleto: "BGR_Informe_Tecnico_2024.pdf",
    },
    {
        id: 13,
        nombre: "JOFILIPES, LDA.",
        fecha: "2025-10-26",
        estado: "Documento vigente",
        tipo: "Revisión programada",
        documento: "Certificado operativo",
        proveedor: "JOFILIPES",
        documentoCompleto: "JOFILIPES_Certificado_Operativo.pdf",
    },
    {
        id: 14,
        nombre: "SAWO RECYKLING KAZIMIERZ SZAŁAPSKI",
        fecha: "2025-11-02",
        estado: "Documento vigente",
        tipo: "Evaluación anual",
        documento: "Informe de gestión",
        proveedor: "SAWO RECYKLING",
        documentoCompleto: "SAWO_Informe_Gestion_2024.pdf",
    },
    {
        id: 15,
        nombre: "CENTRO DE RECICLAJE EXTREMEÑO S.A.",
        fecha: "2025-12-15",
        estado: "Documento vigente",
        tipo: "Renovación anual",
        documento: "Autorización integral",
        proveedor: "CENTRO RECICLAJE",
        documentoCompleto: "Centro_Reciclaje_Autorizacion.pdf",
    },
    {
        id: 16,
        nombre: "ECOSERVICE EXPERT SA",
        fecha: "2025-12-27",
        estado: "Documento vigente",
        tipo: "Auditoría programada",
        documento: "Certificado ambiental",
        proveedor: "ECOSERVICE",
        documentoCompleto: "ECOSERVICE_Certificado_Ambiental.pdf",
    },
];

const CalendarioTab = ({ gestoresData: externalData, filters }) => {
    const [currentYear, setCurrentYear] = useState(
        () => new Date().getFullYear()
    );
    const [eventos, setEventos] = useState(externalData);
    const [filteredEventos, setFilteredEventos] = useState(externalData);
    const [estadoFilter, setEstadoFilter] = useState("Todos");
    const [searchTerm, setSearchTerm] = useState("");
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [selectedDayEvents, setSelectedDayEvents] = useState([]);
    const [showDayModal, setShowDayModal] = useState(false);
    const [selectedDate, setSelectedDate] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
    ];

    const diasSemana = ["Lu", "Ma", "Mi", "Ju", "Vi", "Sa", "Do"];

    const estadoOptions = [
        { value: "Todos", label: "Todos los estados" },
        { value: "Documento vigente", label: "Documento vigente" },
        { value: "Caducidad inminente", label: "Caducidad inminente" },
        { value: "No válido", label: "No válido" },
    ];

    const estadosMapped = {
        1: "Documento vigente",
        2: "Caducidad inminente",
        3: "No válido",
    };

    useEffect(() => {
        console.log("Filtro actual:", estadoFilter);
        console.log("Eventos originales:", eventos.length);

        let filtered = eventos;

        if (estadoFilter !== "Todos") {
            filtered = filtered.filter(
                (evento) => estadosMapped[evento.codEstado] === estadoFilter
            );
        }

        if (searchTerm) {
            filtered = filtered.filter(
                (evento) =>
                    evento.nombre
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase()) ||
                    evento.documento
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
            );
        }

        console.log("Eventos filtrados:", filtered.length);
        setFilteredEventos(filtered);
    }, [eventos, estadoFilter, searchTerm]);

    const generarCalendarioMes = (year, month) => {
        const dias = [];
        const primerDia = new Date(year, month, 1);
        const primerDiaSemana = (primerDia.getDay() + 6) % 7;
        const ultimoDia = new Date(year, month + 1, 0).getDate();

        for (let i = primerDiaSemana - 1; i >= 0; i--) {
            const fecha = new Date(year, month, -i);
            dias.push({
                fecha: fecha.getDate(),
                esDelMes: false,
                fechaCompleta: `${year}-${String(fecha.getMonth() + 1).padStart(
                    2,
                    "0"
                )}-${String(fecha.getDate()).padStart(2, "0")}`,
            });
        }

        for (let dia = 1; dia <= ultimoDia; dia++) {
            dias.push({
                fecha: dia,
                esDelMes: true,
                fechaCompleta: `${year}-${String(month + 1).padStart(2, "0")}-${String(
                    dia
                ).padStart(2, "0")}`,
            });
        }

        const diasRestantes = 42 - dias.length;
        for (let dia = 1; dia <= diasRestantes; dia++) {
            const fecha = new Date(year, month + 1, dia);
            dias.push({
                fecha: dia,
                esDelMes: false,
                fechaCompleta: `${year}-${String(fecha.getMonth() + 1).padStart(
                    2,
                    "0"
                )}-${String(fecha.getDate()).padStart(2, "0")}`,
            });
        }

        return dias;
    };

    const obtenerEventosFecha = (fecha) => {
        const fechaObj = new Date(fecha);
        const dia = String(fechaObj.getDate()).padStart(2, "0");
        const mes = String(fechaObj.getMonth() + 1).padStart(2, "0");
        const año = fechaObj.getFullYear();

        const fechaFormatted = `${dia}/${mes}/${año}`;
        return filteredEventos.filter(
            (evento) => evento.fechaValidez === fechaFormatted
        );
    };

    const handleDayClick = (fechaCompleta, esDelMes) => {
        if (!esDelMes) return;

        const eventosDelDia = obtenerEventosFecha(fechaCompleta);
        if (eventosDelDia.length > 0) {
            setSelectedDayEvents(eventosDelDia);
            setSelectedDate(fechaCompleta);
            setShowDayModal(true);
        }
    };

    const handleSearch = (term) => {
        setSearchTerm(term);
    };

    const handleEstadoFilterChange = (selectedOption) => {
        console.log("Cambiando filtro a:", selectedOption);
        setEstadoFilter(selectedOption.value);
    };

    const contarEventosPorEstado = () => {
        const contadores = {
            1: 0,
            2: 0,
            3: 0,
        };

        eventos.forEach((evento) => {
            if (contadores[evento.codEstado] !== undefined) {
                contadores[evento.codEstado]++;
            }
        });

        return contadores;
    };

    const contadores = contarEventosPorEstado();

    if (loading) {
        return (
            <div className="calendario-tab__loading">
                Cargando calendario...
            </div>
        );
    }

    if (error) {
        return <div className="calendario-tab__error">Error: {error}</div>;
    }

    return (
        <div className="calendario-tab">
            <div className="calendario-tab__year-section">
                <div className="calendario-tab__navigation">
                    <button
                        className="calendario-tab__nav-button"
                        onClick={() => setCurrentYear(currentYear - 1)}
                    >
                        <IoChevronBack />
                    </button>
                    <h2 className="calendario-tab__year">{currentYear}</h2>
                    <button
                        className="calendario-tab__nav-button"
                        onClick={() => setCurrentYear(currentYear + 1)}
                    >
                        <IoChevronForward />
                    </button>
                </div>
            </div>

            <div className="calendario-tab__legend-container">
                <div className="calendario-tab__legend">
                    <div className="calendario-tab__legend-item">
                        <div className="calendario-tab__legend-circle calendario-tab__legend-circle--success"></div>
                        <span className="calendario-tab__legend-text">
                            Documento vigente ({contadores[1]})
                        </span>
                    </div>
                    <div className="calendario-tab__legend-item">
                        <div className="calendario-tab__legend-circle calendario-tab__legend-circle--warning"></div>
                        <span className="calendario-tab__legend-text">
                            Caducidad inminente ({contadores[2]})
                        </span>
                    </div>
                    <div className="calendario-tab__legend-item">
                        <div className="calendario-tab__legend-circle calendario-tab__legend-circle--danger"></div>
                        <span className="calendario-tab__legend-text">
                            No válido ({contadores[3]})
                        </span>
                    </div>
                </div>
                <div className="calendario-tab__filters">
                    <InputDropdown
                        options={estadoOptions}
                        value={estadoFilter}
                        onChange={handleEstadoFilterChange}
                        className="calendario-tab__filter-dropdown"
                    />
                </div>
            </div>

            <div
                className={`calendario-tab__layout ${
                    sidebarCollapsed ? "calendario-tab__layout--collapsed" : ""
                }`}
            >
                <div className="calendario-tab__calendar-section">
                    <div className="calendario-tab__grid">
                        {meses.map((mes, mesIndex) => {
                            const diasMes = generarCalendarioMes(
                                currentYear,
                                mesIndex
                            );

                            return (
                                <div
                                    key={mesIndex}
                                    className="calendario-tab__month"
                                >
                                    <div className="calendario-tab__month-header">
                                        <h3 className="calendario-tab__month-title">
                                            {mes}
                                        </h3>
                                    </div>

                                    <div className="calendario-tab__month-grid">
                                        {diasSemana.map((dia) => (
                                            <div
                                                key={dia}
                                                className="calendario-tab__day-header"
                                            >
                                                {dia}
                                            </div>
                                        ))}

                                        {diasMes.map((dia, diaIndex) => {
                                            const eventosDelDia =
                                                obtenerEventosFecha(
                                                    dia.fechaCompleta
                                                );

                                            return (
                                                <div
                                                    key={diaIndex}
                                                    className={`calendario-tab__day ${
                                                        !dia.esDelMes
                                                            ? "calendario-tab__day--other-month"
                                                            : ""
                                                    } ${
                                                        eventosDelDia.length > 0
                                                            ? "calendario-tab__day--has-events"
                                                            : ""
                                                    }`}
                                                    onClick={() =>
                                                        handleDayClick(
                                                            dia.fechaCompleta,
                                                            dia.esDelMes
                                                        )
                                                    }
                                                >
                                                    <span className="calendario-tab__day-number">
                                                        {dia.fecha}
                                                    </span>

                                                    {eventosDelDia.length >
                                                        0 && (
                                                        <div className="calendario-tab__day-events">
                                                            {eventosDelDia
                                                                .slice(0, 3)
                                                                .map(
                                                                    (
                                                                        evento
                                                                    ) => (
                                                                        <div
                                                                            key={
                                                                                evento.id
                                                                            }
                                                                            className={`calendario-tab__event calendario-tab__event--${
                                                                                evento.codEstado ===
                                                                                1
                                                                                    ? "success"
                                                                                    : evento.codEstado ===
                                                                                        2
                                                                                      ? "warning"
                                                                                      : "danger"
                                                                            }`}
                                                                            title={`${evento.nombre} - ${evento.documento}`}
                                                                        >
                                                                            <div className="calendario-tab__event-dot"></div>
                                                                        </div>
                                                                    )
                                                                )}
                                                            {eventosDelDia.length >
                                                                3 && (
                                                                <div className="calendario-tab__event-more">
                                                                    +
                                                                    {eventosDelDia.length -
                                                                        3}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="calendario-tab__sidebar">
                    <div className="calendario-tab__sidebar-header">
                        <h3>Eventos programados ({filteredEventos.length})</h3>
                        <button
                            className="calendario-tab__collapse-btn"
                            onClick={() =>
                                setSidebarCollapsed(!sidebarCollapsed)
                            }
                            title={
                                sidebarCollapsed
                                    ? "Mostrar eventos"
                                    : "Ocultar eventos"
                            }
                        >
                            {sidebarCollapsed ? (
                                <MdKeyboardArrowLeft />
                            ) : (
                                <MdKeyboardArrowRight />
                            )}
                        </button>
                    </div>

                    {!sidebarCollapsed && (
                        <>
                            <div className="calendario-tab__sidebar-search">
                                <InputSearch
                                    placeholder="Buscar gestor..."
                                    onSearch={handleSearch}
                                />
                            </div>

                            <div className="calendario-tab__sidebar-content">
                                {filteredEventos.map((evento) => (
                                    <div
                                        key={evento.id}
                                        className="calendario-tab__event-item"
                                    >
                                        <div className="calendario-tab__event-status">
                                            <div
                                                className={`calendario-tab__status-dot calendario-tab__status-dot--${
                                                    evento.codEstado === 1
                                                        ? "success"
                                                        : evento.codEstado === 2
                                                          ? "warning"
                                                          : "danger"
                                                }`}
                                                title={
                                                    estadosMapped[
                                                        evento.codEstado
                                                    ]
                                                }
                                            ></div>
                                        </div>

                                        <div className="calendario-tab__event-main">
                                            <div className="calendario-tab__event-name">
                                                {evento.nombre}
                                            </div>
                                            <div className="calendario-tab__event-date">
                                                {evento.fechaValidez}
                                            </div>
                                        </div>

                                        <div className="calendario-tab__event-actions">
                                            <button
                                                className="calendario-tab__document-btn"
                                                onClick={() => {
                                                    console.log(
                                                        `Abriendo documento: ${evento.documento}`
                                                    );
                                                }}
                                                title="Ver documento"
                                            >
                                                <svg
                                                    width="16"
                                                    height="16"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                >
                                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                                    <polyline points="14,2 14,8 20,8" />
                                                    <line
                                                        x1="16"
                                                        y1="13"
                                                        x2="8"
                                                        y2="13"
                                                    />
                                                    <line
                                                        x1="16"
                                                        y1="17"
                                                        x2="8"
                                                        y2="17"
                                                    />
                                                    <polyline points="10,9 9,9 8,9" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>

            <Modal
                isOpen={showDayModal}
                onClose={() => setShowDayModal(false)}
                position="center"
            >
                <div className="calendario-tab__day-modal-content">
                    <h2 className="calendario-tab__day-modal-title">
                        Información
                    </h2>
                    {selectedDayEvents.length > 0 && (
                        <>
                            <div className="calendario-tab__day-modal-info">
                                <p>
                                    <strong>Proveedor:</strong>{" "}
                                    {selectedDayEvents[0].nombre}
                                </p>
                                <p>
                                    <strong>Documento:</strong>{" "}
                                    {selectedDayEvents[0].documento}
                                </p>
                            </div>

                            <div className="calendario-tab__day-modal-actions">
                                <Button
                                    variant="filled"
                                    onClick={() => setShowDayModal(false)}
                                >
                                    Cerrar
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            </Modal>
        </div>
    );
};

export default CalendarioTab;
